// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__OvFOu","unreadBadge":"styles_unreadBadge__3xhbL","modalContent":"styles_modalContent__2pQZr","modal":"styles_modal__A-2nF"};